import { PROMOTION_MESSAGE_TYPES } from "../../pages/myaccount/sms/smsSettingsConfig";

type HolidayDateRow = { name?: string; date?: string };

export type SmsPromotionValidationInput = {
  birthdayEnabled?: boolean;
  birthdayMsg?: string;
  followUpEnabled?: boolean;
  followUpMsg?: string;
  holidayEnabled?: boolean;
  holidayMsg?: string;
  holidayDates?: HolidayDateRow[];
  oralHealthTipEnabled?: boolean;
  oralHealthTipMsg?: string;
  promoEnabled?: boolean;
  promoMsg?: string;
};

export function validateSmsPromotionSettings(data: SmsPromotionValidationInput): string[] {
  const errors: string[] = [];

  for (const rule of PROMOTION_MESSAGE_TYPES) {
    if (Boolean(data[rule.enabledField]) && !String(data[rule.field] || "").trim()) {
      errors.push(`${rule.label} template is required when enabled`);
    }
  }

  if (Boolean(data.holidayEnabled)) {
    const holidayDates = (data.holidayDates || []).filter((item) =>
      String(item?.date || "").trim()
    );
    if (holidayDates.length === 0) {
      errors.push("At least one holiday date is required when holiday greetings are enabled");
    }
  }

  return errors;
}
